import React from 'react'
import utils from './utils'
import { images } from '../../../../services/assets.services'

function getLevelLayout(width, height, settings, quantities, answer) {

    const {
        gameContainerWidth,
        gameContainerHeight,
        curveSideMargin,
        curveWidth,
        marginBottom,
        lineWeight,
        arrowSize,
        fontSize
    } = getLayoutSettings(width, height)

    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}
        >
            {getLayout(width, height, settings, quantities, answer)}
        </svg>
    )
}

function getLayout(width, height, settings, quantities, answer) {
    const orientation = settings.orientation
    const values = getValues(quantities.value_1, quantities.value_2, quantities.value_3, answer, settings)
    let switchValues = false
    if (!values.value_3 && settings.operation === 'subtraction') {
        switchValues = true
        if (orientation === "vertical") {
            let val1Tmp = values[0]
            let answerTmp = values[3]
            values[0] = answerTmp
            values[3] = val1Tmp
        } else {
            let val1Tmp = values[0]
            let val2Tmp = values[1]
            let answerTmp = values[3]
            values[0] = val2Tmp
            values[1] = answerTmp
            values[3] = val1Tmp
        }
    }
    let answerPosition = 0
    if (settings.answer_required === 'value_1') {
        if (switchValues) {
            answerPosition = 4
        } else {
            answerPosition = 1
        }

    } else if (settings.answer_required === 'value_2') {
        if (switchValues && orientation !== "vertical") {
            answerPosition = 1
        } else {
            answerPosition = 2
        }
    } else if (settings.answer_required === 'value_3') {
        answerPosition = 3
    } else if (settings.answer_required === 'answer') {
        if (switchValues) {
            answerPosition = orientation === "vertical" ? 1 : 2
        } else {
            answerPosition = 4
        }
    } else {
        answerPosition = 4
    }

    if (orientation === "vertical") {
        return getVerticalLayout(width, height, settings, quantities, values, answerPosition)
    } else {

        return getHorisontalLayout(width, height, settings, quantities, values, answerPosition)
    }
}

function getVerticalLayout(width, height, settings, quantities, values, answerPosition) {

    const labelsMargin = settings.show_labels ? height / 10 : 0
    const gameContainerWidth = width
    const gameContainerHeight = height - labelsMargin * 2
    const fontSize = 36

    let isTriple = values[2] ? true : false
    let scale = 0
    let gridBgWidth = 350
    let gridBgHeight = 235
    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }
    const labelsMarginScaled = labelsMargin / scale

    let collect1 = []
    let collect2 = []
    let collect3 = []
    let collect4 = []

    const representation = settings.representation
    let labels = null
    let isTextRepr = representation === 'text' ? true : false


    let circleSize = 37

    if (isTriple) {
        collect4 = utils.getCherryRepresentation(values[3], gridBgWidth / 2, labelsMarginScaled + 55, circleSize * 1.6, representation)
        collect1 = utils.getCherryRepresentation(values[0], 50, labelsMarginScaled + 175, circleSize * 1.6, representation)
        collect2 = utils.getCherryRepresentation(values[1], gridBgWidth / 2, labelsMarginScaled + 175, circleSize * 1.6, representation)
        collect3 = utils.getCherryRepresentation(values[2], 300, labelsMarginScaled + 175, circleSize * 1.6, representation)
    } else {
        collect4 = utils.getCherryRepresentation(values[3], gridBgWidth / 2, labelsMarginScaled + 55, circleSize * 1.6, representation)
        collect1 = utils.getCherryRepresentation(values[0], 80, labelsMarginScaled + 175, circleSize * 1.6, representation)
        //collect3 = utils.getSticks(values[2], gridBgWidth - circleSize * 1.8 - lineWeight, gridBgHeight - circleSize * 1.6.9, circleSize * 1.5)
        collect2 = utils.getCherryRepresentation(values[1], 270, labelsMarginScaled + 175, circleSize * 1.6, representation)
    }

    if (settings.show_labels) {
        if (isTriple) {
            labels = (
                <g>
                    <text
                        className="level-text-secondary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={gridBgWidth / 2}
                        y={18}
                        textAnchor="middle"
                    >whole</text>
                    <text
                        className="level-text-secondary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={50}
                        y={270}
                        textAnchor="middle"
                    >part</text>
                    <text
                        className="level-text-secondary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={gridBgWidth / 2}
                        y={270}
                        textAnchor="middle"
                    >part</text>
                    <text
                        className="level-text-secondary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={300}
                        y={270}
                        textAnchor="middle"
                    >part</text>
                </g>
            )
        } else {
            labels = (
                <g>
                    <text
                        className="level-text-secondary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={gridBgWidth / 2}
                        y={18}
                        textAnchor="middle"
                    >whole</text>
                    <text
                        className="level-text-secondary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={80}
                        y={270}
                        textAnchor="middle"
                    >part</text>
                    <text
                        className="level-text-secondary"
                        fontSize={fontSize}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={270}
                        y={270}
                        textAnchor="middle"
                    >part</text>
                </g>
            )
        }
    }

    return isTriple ? (

        <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale) / 2}), scale(${scale})`}>
            <g transform={`translate(0, ${labelsMarginScaled})`}>
                <image
                    width={gridBgWidth}
                    height={gridBgHeight}
                    xlinkHref={images.svg['cherry-1']}

                />
            </g>
            {(isTextRepr || answerPosition === 4) && <text
                className="level-text-secondary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={gridBgWidth / 2}
                y={labelsMarginScaled + 55}
                textAnchor="middle"
            >{values[3]}</text>}

            {(isTextRepr || answerPosition === 1) && <text
                className="level-text-secondary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={50}
                y={labelsMarginScaled + 175}
                textAnchor="middle"
            >{values[0]}</text>}

            {(isTextRepr || answerPosition === 2) && <text
                className="level-text-secondary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={gridBgWidth / 2}
                y={labelsMarginScaled + 175}
                textAnchor="middle"
            >{values[1]}</text>}

            {(isTextRepr || answerPosition === 3) && <text
                className="level-text-secondary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={300}
                y={labelsMarginScaled + 175}
                textAnchor="middle"
            >{values[2]}</text>}

            {answerPosition !== 1 && !isTextRepr && collect1}
            {answerPosition !== 2 && !isTextRepr && collect2}
            {answerPosition !== 3 && !isTextRepr && collect3}
            {answerPosition !== 4 && !isTextRepr && collect4}
            {labels}
        </g>
    ) :
        (
            <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale) / 2}), scale(${scale})`}>
                <g transform={`translate(0, ${labelsMarginScaled})`}>
                    <image
                        width={gridBgWidth}
                        height={gridBgHeight}
                        xlinkHref={images.svg['cherry-2']}
                    />
                </g>

                {(isTextRepr || answerPosition === 4) && <text
                    className="level-text-secondary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={gridBgWidth / 2}
                    y={labelsMarginScaled + 55}
                    textAnchor="middle"
                >{values[3]}</text>}

                {(isTextRepr || answerPosition === 1) && <text
                    className="level-text-secondary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={80}
                    y={labelsMarginScaled + 175}
                    textAnchor="middle"
                >{values[0]}</text>}

                {(isTextRepr || answerPosition === 2) && <text
                    className="level-text-secondary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={270}
                    y={labelsMarginScaled + 175}
                    textAnchor="middle"
                >{values[1]}</text>}

                {answerPosition !== 1 && collect1}
                {answerPosition !== 2 && collect2}
                {answerPosition !== 4 && collect4}
                {labels}
            </g>
        )
}

function getHorisontalLayout(width, height, settings, quantities, values, answerPosition) {
    
    const gameContainerWidth = width
    const gameContainerHeight = height
    const fontSize = 36

    let collect1 = []
    let collect2 = []
    let collect3 = []
    let collect4 = []
    let isTriple = values[2] ? true : false
    const representation = settings.representation
    let labels = null
    let isTextRepr = representation === 'text' ? true : false

    let scale = 0
    let gridBgWidth = 240
    let gridBgHeight = 360
    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    let circleSize = 37

    if (isTriple) {
        collect4 = utils.getCherryRepresentation(values[3], 50, gridBgHeight / 2, circleSize * 1.6, representation)
        collect1 = utils.getCherryRepresentation(values[0], 183, 50, circleSize * 1.6, representation)
        collect2 = utils.getCherryRepresentation(values[1], 183, gridBgHeight / 2, circleSize * 1.6, representation)
        collect3 = utils.getCherryRepresentation(values[2], 183, 308, circleSize * 1.6, representation)
    } else {
        collect4 = utils.getCherryRepresentation(values[3], 50, gridBgHeight / 2, circleSize * 1.6, representation)
        collect1 = utils.getCherryRepresentation(values[0], 183, 80, circleSize * 1.6, representation)
        //collect3 = utils.getSticks(values[2], gridBgWidth - circleSize * 1.8 - lineWeight, gridBgHeight - circleSize * 1.6.9, circleSize * 1.5)
        collect2 = utils.getCherryRepresentation(values[1], 183, 283, circleSize * 1.6, representation)
    }

    return isTriple ? (
        <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale) / 2}), scale(${scale})`}>
            <image
                width={gridBgWidth}
                height={gridBgHeight}
                xlinkHref={images.svg['cherry-3']}

            />
            {(isTextRepr || answerPosition === 4) && <text
                className="level-text-secondary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={50}
                y={gridBgHeight / 2}
                textAnchor="middle"
            >{values[3]}</text>}

            {(isTextRepr || answerPosition === 1) && <text
                className="level-text-secondary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={183}
                y={50}
                textAnchor="middle"
            >{values[0]}</text>}

            {(isTextRepr || answerPosition === 2) && <text
                className="level-text-secondary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={183}
                y={gridBgHeight / 2}
                textAnchor="middle"
            >{values[1]}</text>}

            {(isTextRepr || answerPosition === 3) && <text
                className="level-text-secondary"
                fontSize={fontSize}
                fontWeight="regular"
                dominantBaseline="middle"
                x={183}
                y={308}
                textAnchor="middle"
            >{values[2]}</text>}

            {answerPosition !== 1 && !isTextRepr && collect1}
            {answerPosition !== 2 && !isTextRepr && collect2}
            {answerPosition !== 3 && !isTextRepr && collect3}
            {answerPosition !== 4 && !isTextRepr && collect4}
        </g>
    ) :
        (
            <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale) / 2}), scale(${scale})`}>

                <image
                    width={gridBgWidth}
                    height={gridBgHeight}
                    xlinkHref={images.svg['cherry-4']}

                />
                {(isTextRepr || answerPosition === 4) && <text
                    className="level-text-secondary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={50}
                    y={gridBgHeight / 2}
                    textAnchor="middle"
                >{values[3]}</text>}

                {(isTextRepr || answerPosition === 1) && <text
                    className="level-text-secondary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={183}
                    y={80}
                    textAnchor="middle"
                >{values[0]}</text>}

                {(isTextRepr || answerPosition === 2) && <text
                    className="level-text-secondary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={183}
                    y={283}
                    textAnchor="middle"
                >{values[1]}</text>}

                {answerPosition !== 1 && !isTextRepr && collect1}
                {answerPosition !== 2 && !isTextRepr && collect2}
                {answerPosition !== 4 && !isTextRepr && collect4}
            </g>
        )
}

function getLayoutSettings(gameContainerWidth, gameContainerHeight) {

    /* const gameContainerMargin = 0//gameContainerWidth / 20

    if (gameContainerWidth > gameContainerHeight) {
        gameContainerWidth = gameContainerHeight - gameContainerMargin
        gameContainerHeight = gameContainerHeight - gameContainerMargin
    } else {
        gameContainerWidth = gameContainerWidth - gameContainerMargin
        gameContainerHeight = gameContainerWidth - gameContainerMargin
    } */

    const sideMargin = gameContainerWidth * .1

    const circleSize = gameContainerWidth / 7
    const marginBottom = 0
    const lineWeight = gameContainerWidth / 150
    const arrowSize = gameContainerWidth / 35
    const fontSize = 36

    return {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        circleSize,
        marginBottom,
        lineWeight,
        arrowSize,
        fontSize
    }
}

function getValues(value_1, value_2, value_3, answer, settings) {
    const operation = settings.operation
    const answerRequired = settings.answer_required || 'answer'
    value_3 = value_3 && !isNaN(value_3) ? +value_3 : 0

    if (settings.show_tens) {
        if (operation === 'addition') {
            if (answerRequired === 'value_1') {
                answer = utils.isPowerOfTen(value_1) ? answer + ' tens' : answer
                return [answer, utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'value_2') {
                answer = utils.isPowerOfTen(value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), answer, utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'value_3') {
                answer = utils.isPowerOfTen(value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), answer, utils.getTens(value_1 + value_2 + value_3)]
            } else if (answerRequired === 'answer') {
                answer = utils.isPowerOfTen(value_1 + value_2 + value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), answer]
            } else {
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 + value_2 + value_3)]
            }
        } else {
            if (answerRequired === 'value_1') {
                answer = utils.isPowerOfTen(value_1) ? answer + ' tens' : answer
                return [answer, utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'value_2') {
                answer = utils.isPowerOfTen(value_2) ? answer + ' tens' : answer
                return [utils.getTens(value_1), answer, utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'value_3') {
                answer = utils.isPowerOfTen(value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), answer, utils.getTens(value_1 - value_2 - value_3)]
            } else if (answerRequired === 'answer') {
                answer = utils.isPowerOfTen(value_1 - value_2 - value_3) ? answer + ' tens' : answer
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), answer]
            } else {
                return [utils.getTens(value_1), utils.getTens(value_2), utils.getTens(value_3), utils.getTens(value_1 - value_2 - value_3)]
            }
        }
    } else {
        if (operation === 'addition') {
            if (answerRequired === 'value_1') {
                return [answer, value_2, value_3, value_1 + value_2 + value_3]
            } else if (answerRequired === 'value_2') {
                return [value_1, answer, value_3, value_1 + value_2 + value_3]
            } else if (answerRequired === 'value_3') {
                return [value_1, value_2, answer, value_1 + value_2 + value_3]
            } else if (answerRequired === 'answer') {
                return [value_1, value_2, value_3, answer]
            } else {
                return [value_1, value_2, value_3, value_1 + value_2 + value_3]
            }
        } else {
            if (answerRequired === 'value_1') {
                return [answer, value_2, value_3, value_1 - value_2 - value_3]
            } else if (answerRequired === 'value_2') {
                return [value_1, answer, value_3, value_1 - value_2 - value_3]
            } else if (answerRequired === 'value_3') {
                return [value_1, value_2, answer, value_1 - value_2 - value_3]
            } else if (answerRequired === 'answer') {
                return [value_1, value_2, value_3, answer]
            } else {
                return [value_1, value_2, value_3, value_1 - value_2 - value_3]
            }
        }
    }
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/cherry.utils.js